import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-3 d-flex" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center pt-1"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", { class: "sm" }, "+41 011 782791", -1)
const _hoisted_4 = { class: "mt-1 secondary-text" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "$14.99", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "**** 5642", -1)
const _hoisted_11 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "$14.99", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Monthly subscription", -1)
const _hoisted_15 = { class: "d-flex" }
const _hoisted_16 = { class: "mt-5" }
const _hoisted_17 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "New Package", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_SelectDropdown = _resolveComponent("SelectDropdown")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { title: "Package" }, {
      title: _withCtx(() => [
        _createVNode(_component_AppBadge, {
          type: _ctx.activeTo ? 'success' : 'danger',
          size: "md",
          rounded: false,
          class: "ms-auto static-color"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.activeTo ? "Active" : "In Active"), 1)
          ]),
          _: 1
        }, 8, ["type"])
      ]),
      footer: _withCtx(() => [
        (_ctx.esimType === 'withNumber')
          ? (_openBlock(), _createBlock(_component_AppButton, {
              key: 0,
              type: "primary-transparent",
              size: "md-fluid",
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" History Logs ")
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_AppButton, {
              key: 1,
              type: "primary-transparent",
              size: "md-fluid",
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" eSIM Profile Packages History ")
              ]),
              _: 1
            }))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_SelectDropdown, {
          "on-select": _ctx.planOptionsSelectHandler,
          list: _ctx.planOptions,
          "check-type": "radio",
          "inline-mode": true
        }, null, 8, ["on-select", "list"]),
        (_ctx.esimType === 'withNumber')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_SvgIcon, {
                class: "me-2",
                icon: "phone"
              }),
              _hoisted_3
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode(" Purchased on " + _toDisplayString(_ctx.getFormatDateActiveFrom) + " ", 1),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.validitiTill), 1)
        ]),
        (_ctx.esimType === 'withNumber')
          ? (_openBlock(), _createElementBlock("strong", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createTextVNode(" One-time payment with "),
              _hoisted_9,
              _createTextVNode(" Credit Card ending "),
              _hoisted_10
            ]))
          : (_openBlock(), _createElementBlock("strong", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _createElementVNode("span", _hoisted_15, [
                _createTextVNode(" With "),
                _createVNode(_component_svg_icon, {
                  class: "ms-1",
                  icon: "apple"
                })
              ])
            ])),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_AppButton, {
            type: "secondary",
            size: "md-fluid"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_SvgIcon, {
                  icon: "plus",
                  class: "me-2"
                }),
                _hoisted_18
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}